import React from 'react';
import EImg from './EImg';
import EmojiUnicorn from './emoji-unicorn.png';

export default ({ width = 24, height = 24 }) => (
	<EImg width={width} height={height} title="Unicorn" aria-label="Emoji: Unicorn" alt="🦄" src={EmojiUnicorn} />
);
